import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { createContext, useContext, useEffect, useMemo } from 'react';
import cn from 'classnames';
import { useStateInRef } from '../../utils/useStateInRef';
import { useDevice } from '../Device';
import styles from './Theme.module.scss';
import { getFullTheme } from './Theme.utils';
const ThemeContext = /*#__PURE__*/ createContext({});
export const useTheme = ()=>useContext(ThemeContext);
export function ScopedThemeProvider(props) {
    const { theme, children, className, maxHeight, maxWidth, testId, style } = props;
    const fullTheme = useMemo(()=>getFullTheme(theme), [
        theme
    ]);
    const { isMobileDevice } = useDevice();
    return /*#__PURE__*/ _jsx(ThemeContext.Provider, {
        value: fullTheme,
        children: /*#__PURE__*/ _jsx("div", {
            className: cn(className, {
                [styles.maxHeight]: maxHeight,
                [styles.maxWidth]: maxWidth
            }),
            style: _object_spread({}, style, fullTheme),
            "data-device": isMobileDevice ? 'mobile' : undefined,
            "data-testid": testId,
            children: children
        })
    });
}
export function RootThemeProvider(props) {
    const { theme, children } = props;
    const getTheme = useStateInRef(theme);
    useEffect(()=>{
        const root = document.documentElement;
        Object.entries(getFullTheme(getTheme())).forEach((param)=>{
            let [key, value] = param;
            root.style.setProperty(key, value);
        });
    }, []);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
}
